import { JSONClient } from './bootstrap';
import TidalException from './exception';

export const createCredential = async (
  type: string,
  nickName: string,
  access_key_id: string,
  secret_access_key: string,
  gcpConfig: any,
) => {
  try {
    if (type == 'aws') {
      const res = await JSONClient.post(
        `/dashboard/servers/credentials/${type}`,
        {
          nickName,
          config: {
            access_key_id,
            secret_access_key,
          },
        },
      );
      return res.data;
    }
    if (type == 'gcp') {
      const res = await JSONClient.post(
        `/dashboard/servers/credentials/${type}`,
        {
          nickName,
          config: gcpConfig,
        },
      );
      return res.data;
    }
  } catch (e) {
    throw new TidalException(e.response.data.message, e.response.data.error);
  }
};

export const deleteCredential = async (type: string) => {
  try {
    const res = await JSONClient.delete(
      `/dashboard/servers/credentials/${type}`,
    );
    return res.data;
  } catch (e) {
    throw new TidalException(e.response.data.message, e.response.data.error);
  }
};

export const createServer = async ({
  platform,
  region,
  ami,
  instanceType,
  quantity,
  user,
  pass,
  disableSecurity,
  storage,
  name,
  operatingSystem,
  networkName,
  destroyAt,
  snapshotProviderId,
}) => {
  try {
    const res = await JSONClient.post(`/dashboard/servers/${platform}`, {
      region,
      ami,
      instanceType,
      quantity,
      user,
      pass,
      disableSecurity,
      storage,
      name,
      operatingSystem,
      networkName,
      destroyAt,
      snapshotProviderId,
    });
    return res.data;
  } catch (e) {
    throw new TidalException(e.response.data.message, e.response.data.error);
  }
};

// export const pollServer = async ({ provider, region, instanceId, ip, id, auth, token }) => {
export const pollServer = async ({ data, provider }) => {
  try {
    const res = await JSONClient.post(
      `/dashboard/servers/${provider}/wait`,
      data,
    );
    return res.data;
  } catch (e) {
    throw new TidalException(e.response.data.message, e.response.data.error);
  }
};

export const getServers = async () => {
  try {
    const res = await JSONClient.get('/dashboard/servers');
    return res.data;
  } catch (e) {
    throw new TidalException(e.response.data.message, e.response.data.error);
  }
};

export const serverAction = async ({ serverId, action }) => {
  try {
    const res = await JSONClient.put(
      `/dashboard/servers/${serverId}/${action}`,
      {},
    );
    return res.data;
  } catch (e) {
    throw new TidalException(e.response.data.message, e.response.data.error);
  }
};

export const deleteServer = async ({ serverId }) => {
  try {
    const res = await JSONClient.delete(`/dashboard/servers/${serverId}`);
    return res.data;
  } catch (e) {
    throw new TidalException(e.response.data.message, e.response.data.error);
  }
};

export const deleteServerSnapshot = async ({ snapshotId }) => {
  try {
    const res = await JSONClient.delete(
      `/dashboard/servers/snapshot/${snapshotId}`,
    );
    return res.data;
  } catch (e) {
    throw new TidalException(e.response.data.message, e.response.data.error);
  }
};
